import { addYears, format, parse } from "date-fns";
import { isNil } from "lodash";

interface ConvertParams {
  value: string | number | undefined;
  dateOfBirth: string | null; // Format yyyy-MM-dd
}

export const convertAgeToDate = ({
  value,
  dateOfBirth,
}: ConvertParams): Date | undefined => {
  if (
    isNil(value) ||
    isNil(dateOfBirth) ||
    dateOfBirth === "" ||
    value === ""
  ) {
    return undefined;
  }

  const birthDateObject = parse(dateOfBirth, "yyyy-MM-dd", new Date());

  const age = Number(value);

  return addYears(birthDateObject, age);
};

type FormatParams = {
  formatString: "yyyy-MM-dd" | "yyyy";
} & ConvertParams;

export const convertAndFormatAgeToDateString = ({
  value,
  dateOfBirth,
  formatString,
}: FormatParams): string => {
  const date = convertAgeToDate({ value, dateOfBirth });

  if (date === undefined) {
    return "";
  }

  return format(date, formatString);
};
